export default __webpack_public_path__ + "static/media/industry-company-img.a6525cbd.jpg";